module.exports = __webpack_public_path__ + "static/armblade_warforged-d2cbf3ee23e62c3ceff5fb6a0cd7171d.png";